import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";

import SXPAttendeesToSchoolTODO from "./Parts/SXPAttendeesToSchoolTODO";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_Null_School_Or_Country_Attendees } from "../../Misc/api/Get_Null_School_Or_Country_Attendees";
import { Get_Null_Country_Schools } from "../../Misc/api/Get_Null_Country_Schools";
import AttendeesToSchoolTODO from "./Parts/AttendeeToSchoolTODO";
import CountryToSchoolTODO from "./Parts/CountryToSchoolTODO";
import SchoolToHubSpotTODO from "./Parts/SchoolToHubSpotTODO";

function ToDo() {
  const { logout } = StaffuseAuth();

  return (
    <div style={{ backgroundColor: "#e5e5e5" }}>
      {" "}
      <div
        name="space"
        style={{ width: "100%", height: "20px", flex: "0 1 auto" }}
      ></div>
      <Typography variant="h6" gutterBottom>
        Things To Do:
      </Typography>
      <SXPAttendeesToSchoolTODO />
      <AttendeesToSchoolTODO />
      <CountryToSchoolTODO />
      <SchoolToHubSpotTODO />
    </div>
  );
}

export default ToDo;
